import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from '../../../entities/user/types';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  companyId: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  companyId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ user: User; companyId: string | null }>) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.companyId = action.payload.companyId;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.companyId = null;
    },
    switchCompany: (state, action: PayloadAction<string | null>) => {
      state.companyId = action.payload;
    },
  },
});

export const { login, logout, switchCompany } = authSlice.actions;
export default authSlice.reducer;
